
import OcDrawer from '@marketplace/components/shared/drawer/oc-drawer.vue'
import ocDrawerMixin from '@marketplace/components/shared/drawer/ocDrawerMixin.js'
import {
    findCategoryByPath,
    getParentCategoryByPath,
} from '@marketplace/helpers/category.js'
import { trackClick } from '@marketplace/helpers/segment/index.js'
import { mapGetters } from 'vuex'

export default {
    name: 'HeaderMobileMenu',

    components: {
        OcDrawer,
    },

    mixins: [ocDrawerMixin],

    props: {
        mode: {
            type: String,
            default: 'marketplace',
        },
    },

    data() {
        return {
            categoryPath: null,
        }
    },

    computed: {
        ...mapGetters('marketplace', ['categories', 'navigation']),
        ...mapGetters('global', ['preferredView']),

        activeCategory() {
            if (this.categoryPath) {
                const category = findCategoryByPath(
                    this.categories,
                    this.categoryPath
                )

                if (category?.children.length > 0) {
                    return category
                }

                return getParentCategoryByPath(
                    this.categories,
                    this.categoryPath
                )
            }

            return null
        },

        currentCategories() {
            if (this.activeCategory) {
                return this.activeCategory.children
            }

            return this.categories
        },
    },

    watch: {
        $route: 'setCategoryFromRoute',
    },

    mounted() {
        this.setCategoryFromRoute()
    },

    methods: {
        prismicCanBeShown(type) {
            switch (type) {
                case 'show to all users':
                    return true
                case 'show to logged-in users':
                    return this.$helpers.isLoggedIn
                case 'show to retailers':
                    return this.$helpers.isRetailerAccount
                default:
                    return false
            }
        },

        setCategoryFromRoute() {
            const path = this.$route.params.categoryPath

            if (path) {
                const category = findCategoryByPath(this.categories, path)

                if (category?.children?.length > 0) {
                    this.categoryPath = category.path
                } else {
                    this.categoryPath = getParentCategoryByPath(
                        this.categories,
                        path
                    )?.path
                }
            } else {
                this.categoryPath = null
            }
        },

        getUri(category) {
            if (!this.$helpers.isLoggedIn || category.depth === 0) {
                return `/marketplace/${category.path}`
            }

            if (this.preferredView) {
                return `/${this.preferredView}/${category.path}`
            }

            return `/wall/${category.path}`
        },

        handleClick(category) {
            if (category?.children.length > 0) {
                this.categoryPath = category.path
            } else {
                if (category.path === this.categoryPath) {
                    return
                }

                const uri = this.getUrl(this.getUri(category))

                if (this.$route.path !== uri) {
                    this.$router.push(uri)
                }

                this.__openDrawer(false)
            }
        },

        handleBack() {
            if (this.activeCategory?.depth > 0) {
                const parent = getParentCategoryByPath(
                    this.categories,
                    this.categoryPath
                )

                this.categoryPath = parent.path
            } else {
                this.categoryPath = null
            }
        },

        trackCategoryClick(category) {
            const title =
                category.depth > 0
                    ? 'Mobile Header Category - Sub'
                    : 'Mobile Header Category - Main'
            trackClick(title, {
                category: 'Header',
                mainCategory: category.slug,
            })
        },

        getUrl(url) {
            if (this.mode === 'dropshipping') {
                return decodeURIComponent(this.localePath(`/ds${url}`))
            }

            return decodeURIComponent(this.localePath(url))
        },

        trackTopBrandClick(brand) {
            trackClick('Header Category - Top Brand', {
                category: 'Header',
                mainCategory: this.categoryPath,
                brand: brand.name,
            })
        },
    },
}
